const hasValue = (value: unknown): boolean =>
  value !== undefined && value !== null && value !== "";

/**
 * Returns true when the cell value is a grid-level default rather than real
 * data from the server.  Used to avoid showing benchmark indicators on cells
 * whose only "value" was injected by getValueWithDefault.
 */
export const isGridDefault = (
  value: unknown,
  benefit:
    | { defaultValue?: unknown; cell?: Record<string, unknown> }
    | undefined,
): boolean => {
  if (!hasValue(value)) return true;
  if (benefit?.defaultValue !== undefined && value === benefit.defaultValue)
    return true;
  if (
    benefit?.cell?.["dataType"] === "array" &&
    Array.isArray(value) &&
    value.length === 0
  )
    return true;
  return false;
};
